import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPayload } from "../../store/actions";
import endPoints from "../../store/utils/endPoints";

const TimeFrame = ({ timeFrame, setTimeFrame }) => {
  const { timeFrames } = useSelector((state) => state.filters);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!timeFrames) {
      dispatch(getPayload(endPoints.timeFrames));
    }
  }, []);
  return (
    <div className="select-bar">
      {timeFrames ? (
        <select
          className="form-control"
          value={timeFrame}
          onChange={(e) => setTimeFrame(e.target.value)}
        >
          {timeFrames.result.filter_time_range.map((element, index) => (
            <option key={element} value={element}>
              {element}
            </option>
          ))}
        </select>
      ) : (
        <div className="">
          <div className="spinner-grow text-dark" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(TimeFrame);
